import React from "react";

import { useIntl } from "react-intl";
import styled from "styled-components";

import config from "console_config";
import Button from "src/root/pages/components/Button";
import { calcColumnWidth } from "src/root/pages/utils/layout";

const ReturnLink = styled(Button)`
  color: var(--snow) !important;
  display: flex !important;
  align-items: center;
  justify-content: center;
`;

const ErrorPageButton = () => {
  const intl = useIntl();

  return (
    <ReturnLink
      variant="primary"
      href={config.URL_REDIRECT_AUTH_USER}
      width={`calc(${calcColumnWidth(2, 6, "end", true)} - 16px)`}
    >
      {intl.formatMessage({ id: "back_to_console" })}
    </ReturnLink>
  );
};

export default ErrorPageButton;
